import { api } from "api/api";
import { AxiosError } from "axios";
import TransacaoNotaFiscal from "model/fiscal/TransacaoNotaFiscal";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class TransacaoNotaFiscalService implements BaseServiceCadastros<TransacaoNotaFiscal> {

    getAll() {
        return new Promise<TransacaoNotaFiscal[]>((resolve, reject): void => {
            api.get(`/transacaoNotaFiscal/getAll`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/transacaoNotaFiscal/pesquisar`;
            url += getFilters(filters);
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<TransacaoNotaFiscal>((resolve, reject): void => {
            api
                .get(`/transacaoNotaFiscal/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(transacaoNotaFiscal: TransacaoNotaFiscal) {
        return new Promise<TransacaoNotaFiscal>((resolve, reject): void => {
            api
                .post(`/transacaoNotaFiscal/incluir`, JSON.stringify(transacaoNotaFiscal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(transacaoNotaFiscal: TransacaoNotaFiscal) {
        return new Promise<TransacaoNotaFiscal>((resolve, reject): void => {
            api
                .put(`/transacaoNotaFiscal/editar`, JSON.stringify(transacaoNotaFiscal))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/transacaoNotaFiscal/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getListaFinalidadeNfe() {
        return [
            { value: "NORMAL", label: "Normal" },
            { value: "COMPLEMENTAR", label: "Complementar" },
            { value: "AJUSTE", label: "Ajuste" },
            { value: "DEVOLUCAO", label: "Devolução" }
        ];
    }

    getFinalidadeNfe(finalidadeNfe: string) {
        return this.getListaFinalidadeNfe().find(item => item.value === finalidadeNfe)?.label || "";
    }

    getListaDestinoOperacao() {
        return [
            { value: "INTERNA", label: "Operação interna" },
            { value: "INTERESTADUAL", label: "Operação interestadual" },
            { value: "EXTERIOR", label: "Operação com o exterior" }
        ];
    }

    getDestinoOperacao(destinoOperacao: string) {
        return this.getListaDestinoOperacao().find(item => item.value === destinoOperacao)?.label || "";
    }

    getListaTipoOperacao() {
        return [
            { value: "ENTRADA", label: "Entrada" },
            { value: "SAIDA", label: "Saída" }
        ];
    }

    getTipoOperacao(tipoOperacao: string) {
        return this.getListaTipoOperacao().find(item => item.value === tipoOperacao)?.label || "";
    }

}
export default TransacaoNotaFiscalService;
